export default [
  {
    header: 'All',
  },
  {
    title: 'Mechanics',
    route: 'v1_blank1',
    icon: 'none',
  },
  {
    title: 'Science',
    route: 'v1_blank2',
    icon: 'none',
  },
  {
    title: 'Engineering',
    route: 'v1_blank3',
    icon: 'none',
  },
  {
    title: 'Control Systems',
    route: 'v1_blank4',
    icon: 'none',
  },
  
]
